
import { message } from "antd";
import FetchData from '@ezviz/FetchData';
import util from './../../utils/utils';
import moment from "moment";
import { version } from "codemirror";
import intl from 'react-intl-universal';
export const GET_HARDWARE_PRD_INFO = "GET_HARDWARE_PRD_INFO";
export const UPDATE_HARDWARE_DATA = "UPDATE_HARDWARE_DATA";
export const UPDATE_REQUEST_STATUS = "UPDATE_REQUEST_STATUS";
export const GET_MODULE_LIST = "GET_MODULE_LIST";

moment.locale("zh-cn");

message.config({
  top: 300,
  maxCount: 3,
});

/**
 * 获取模组列表
 * @param {*} params 
 */
export function getModuleList(params) {
  return (dispatch, getState) => {
    const defaultParam = {};
    const req = Object.assign({}, defaultParam, params);
    const fetchData = new FetchData(`/iot/config/api/iot/support/product/model/info`, {
      method: "GET",
      body: req,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(data => {
        if (data.code == 200) {
          dispatch({
            type: GET_MODULE_LIST,
            moduleList: data.data || []
          });
        } else {
          dispatch({
            type: GET_MODULE_LIST,
            moduleList: []
          });
          message.error(intl.get('commmon.operate.retry'));
        }
      })
      .catch(e => {
        dispatch({
          type: GET_MODULE_LIST,
          moduleList: []
        });
        message.error(intl.get('commmon.operate.retry'));
      });
  };
}

/**
 * 选择模组
 * @param {*} params 
 */
export function selectModule(params, callback, failback) {
  return (dispatch, getState) => {
    const currentProductInfo = JSON.parse(util.getStorage('ezviz_iot_current_product_info'));
    const { productId, firmwareUpgradeCode } = currentProductInfo;
    const defaultParam = {
      pId: productId,
      firmwareUpgradeCode: firmwareUpgradeCode,
      modelId: ''
    };
    const req = Object.assign({}, defaultParam, params);
    const fetchData = new FetchData(
      `/iot/config/api/iot/support/product/modelId/config`,
      {
        method: "POST",
        body: req,
        metaHandler: {
          403: () => { window.location.href = '/authrization/login'; return; }
        },
      }
    );
    fetchData
      .then((data) => {
        message.destroy()
        if (data.code === "200") {
          message.success(intl.get('commmon.operate.success'), 1.5)
          callback && callback();
        } else {
          message.error(intl.get('commmon.operate.retry'));
        }
      })
      .catch((e) => {
        message.destroy()
        message.error(intl.get('commmon.operate.retry'));
      });
  };
}

/**
 * 初始化模组配置
 * @param {*} params 
 */
export function initModule(params, callback, failback) {
  return (dispatch, getState) => {
    const currentProductInfo = JSON.parse(util.getStorage('ezviz_iot_current_product_info'));
    const { productId, firmwareUpgradeCode } = currentProductInfo;
    const defaultParam = {
      pId: productId,
      firmwareUpgradeCode: firmwareUpgradeCode,
    };
    const req = Object.assign({}, defaultParam, params);
    const fetchData = new FetchData(
      `/iot/config/api/iot/support/product/model/init`,
      {
        method: "POST",
        body: req,
        metaHandler: {
          403: () => { window.location.href = '/authrization/login'; return; }
        },
      }
    );
    fetchData
      .then((data) => {
        if (data.code === "200") {
          callback && callback();
        } else {
          failback && failback();
        }
      })
      .catch((e) => {
        failback && failback();
      });
  };
}


export function updateHardwareDefaultData(hardwareData) {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_HARDWARE_DATA,
      hardwareData,
    });
  };
}

function calculate(item) {
  let str1 = "";
  let str2 = "";
  // 0：冷光 ；1：暖光；2：红 ；3：绿；4：蓝；5：CCT；6：亮度

  switch (item.light) {
    case 0:
      str1 = "cold"; // IO4
      break;
    case 1:
      str1 = "warm"; // IO5
      break;
    case 2:
      str1 = "红光引脚"; // IO12
      break;
    case 3:
      str1 = "绿光引脚"; // IO13
      break;
    case 4:
      str1 = "蓝光引脚"; // IO14
      break;
    case 5:
      str1 = "CCT引脚"; // IO14
      break;
    case 6:
      str1 = "亮度引脚"; // IO14
      break;
    default:
      break;
  }
  //GPIO的名字，目前有IO 4、5、12、13、14
  switch (item.name) {
    case 4:
      str2 = "GPI01"; // IO4
      break;
    case 5:
      str2 = "GPI02"; // IO5
      break;
    case 12:
      str2 = "GPI03"; // IO12
      break;
    case 13:
      str2 = "GPI04"; // IO13
      break;
    case 14:
      str2 = "GPI05"; // IO14
      break;
    default:
      break;
  }
  return str2 + str1;
}

function switchTheCurrentGPIOKey(value) {
  // GPIO的名字，目前有IO 4、5、12、13、14 ()_________________
  // • GPIO1、2、3、4、5，分别对应IO 4、5、12、13、14；
  const getV = value.substr(0, 5);
  switch (getV) {
    case "GPI01":
      return "4"; // IO4
    case "GPI02":
      return "5"; // IO5
    case "GPI03":
      return "12"; // IO12
    case "GPI04":
      return "13"; // IO13
    case "GPI05":
      return "14"; // IO14
    default:
      break;
  }
}

/**
 * 获取产品详情，主要用于获取硬件配置信息
 * @param {*} params 
 */
export function getProductDetail(params) {
  return (dispatch, getState) => {
    const currentProductInfo = JSON.parse(util.getStorage('ezviz_iot_current_product_info'));
    const { firmwareUpgradeCode, productId, category } = currentProductInfo;
    const defaultParam = {
      productId,
      firmwareUpgradeCode: firmwareUpgradeCode
    };
    const req = Object.assign({}, defaultParam, params);
    dispatch({
      type: UPDATE_REQUEST_STATUS,
      requestStatus: 'loading',
    });
    const fetchData = new FetchData(
      `/iot/config/api/iot/operation/getPIdDetailInfo?pId=${req.productId}&firmwareUpgradeCode=${req.firmwareUpgradeCode}`,
      {
        method: "POST",
        metaHandler: {
          403: () => { window.location.href = '/authrization/login'; return; }
        },
      }
    );
    fetchData
      .then((data) => {
        dispatch({
          type: UPDATE_REQUEST_STATUS,
          requestStatus: 'noRequest',
        });
        if (data.code == 200) {
          if (category == 'light-rgb-wifi') {
            const defaultObj = {
              "product_subtype": undefined,
              "temperature_drive_mode": undefined,
              "product_type": undefined,
              "device": {
                "dev_name": undefined,
                "ap_prefix": undefined,
                "module_type": undefined,
                "user_defined_type": undefined,
                "category": undefined
              },
              "product_param": {
                "ap_key": undefined,
                "reset_switch_times": undefined,
                "function": {
                  "color_mode": undefined,
                  "power_memory": undefined,
                  "brightness_upper": undefined,
                  "brightness_lower": undefined,
                  "power_on_light": undefined,
                  "memory_timval": undefined,
                  "ap_timval": undefined,
                  "reset_time_lower": undefined,
                  "reset_time_upper": undefined,
                  "default_cct": undefined
                },
                "product_test_param": {
                  "step1time": undefined,
                  "order": undefined
                },
                "IO_config": [
                  {
                    "mode": 1,
                    "drive_mode": 0,
                    "light": 1,
                    "enable": 1,
                    "drive_mode_param": {
                      "pwm_frequency": 1000
                    },
                    "name": 5
                  }
                ]
              }
            }
            const mconfigInfo = data.data.mconfigInfo || JSON.stringify(defaultObj);
            const { product_param } = JSON.parse(mconfigInfo);
            const { IO_config } = product_param;
            const postData = [];
            let isModeColdOrWarm = "cold";
            for (let i = 0; i < IO_config.length; i++) {
              const postInfo = {};
              const getStr = calculate(IO_config[i]);
              postInfo.compareName = getStr;
              postInfo.name = switchTheCurrentGPIOKey(getStr);
              postData.push(postInfo);
            }
            for (let i = 0; i < IO_config.length; i++) {
              if (IO_config[i].light === 1) {
                isModeColdOrWarm = "warm";
              }
            }
            const obj = {
              currentWarmOrColdMode: isModeColdOrWarm,
              textAreaValue: "",
              currentLightGPIO: postData || [],
            };
            const newObj = Object.assign(
              {},
              obj,
              JSON.parse(mconfigInfo)
            );
            dispatch({
              type: UPDATE_HARDWARE_DATA,
              hardwareData: newObj || {},
            });
          } else {
            dispatch({
              type: UPDATE_HARDWARE_DATA,
              hardwareData: data.data.mconfigInfo || {},
            });
          }
          dispatch({
            type: GET_HARDWARE_PRD_INFO,
            pIdDetail: data.data || {},
          });
        }
      })
      .catch((e) => {
        dispatch({
          type: UPDATE_REQUEST_STATUS,
          requestStatus: 'noRequest',
        });
        message.error(intl.get('commmon.operate.retry'));
      });
  };
}

/**
 * 获取产品详情，主要用于获取硬件配置信息
 * @param {*} params 
 */
export function updateHardwareConfig(params, callback) {
  return (dispatch, getState) => {
    const currentProductInfo = JSON.parse(util.getStorage('ezviz_iot_current_product_info'));
    const { productId } = currentProductInfo;
    const defaultParam = {
      PTID: productId
    };
    const req = Object.assign({}, defaultParam, params);
    const fetchData = new FetchData(
      `/iot/config/api/iot/support/product/model/config`,
      {
        method: "POST",
        body: req,
        metaHandler: {
          403: () => { window.location.href = '/authrization/login'; return; }
        },
      }
    );
    fetchData
      .then((data) => {
        message.destroy()
        if (data.code === "200") {
          message.success(intl.get('commmon.operate.success'), 1.5)
          callback && callback();
        } else {
          message.error(intl.get('commmon.operate.retry'));
        }
      })
      .catch((e) => {
        message.destroy()
        message.error(intl.get('commmon.operate.retry'));
      });
  };
}
